import { lighten, PaletteOptions, ThemeOptions } from '@mui/material';
import { defaultThemeOptions } from './';

const COBALT = '#2D44C6';
const INDIGO = '#17243F';
const CARBON = '#171C23';
const GREEN = '#75FBAB';
const AQUA = '#90FCFF';
const SMOKE = '#F5F5F3';
const CRIMSON = '#B42318';

const palette: PaletteOptions = {
  common: {
    black: CARBON,
    white: '#ffffff',
  },
  // Pinned to the MUI default greys this theme already rendered, so the neutral
  // rename is a no-op here and only the F5 scheme retints. Each token takes the
  // shade that dominated its call sites.
  subtleGray: '#f5f5f5',
  lightGray: '#eeeeee',
  gray: '#bdbdbd',
  darkGray: '#757575',
  divider: '#eeeeee',
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    app: '#eeeeee',
  },
  surface: {
    primary: {
      main: INDIGO,
    },
    secondary: {
      main: '#314D87',
    },
    info: {
      main: '#06aed41f',
    },
    error: {
      main: '#f044381f',
    },
    warning: {
      main: '#f5cb9654',
    },
    success: {
      main: '#12d4061f',
    },
    disabled: {
      main: SMOKE,
    },
    successHighlight: {
      main: GREEN,
    },
    infoHighlight: {
      main: AQUA,
    },
    grey: {
      main: '#bdbdbd',
    }
  },
  primary: {
    main: COBALT,
  },
  secondary: {
    main: INDIGO,
  },
  link: {
    main: '#314D87',
    hover: '#314D87',
  },
  success: {
    main: '#659d68',
  },
  error: {
    main: '#ea554e',
  },
  navigation: {
    background: INDIGO,
    text: '#ffffff',
    hover: '#f8f8f824',
    hoverText: '#ffffff',
    selected: COBALT,
    selectedText: '#ffffff',
    divider: '#314D87',
    footer: '#2E497F',
    scrollbar: '#ffffff35',
  },
  chip: {
    label: INDIGO,
    infoBackground: '#e1f5fa',
    primaryBackground: lighten(COBALT, 0.85),
    secondaryBackground: lighten(INDIGO, 0.85),
    greyBackground: '#e0e0e0',
    criticalBackground: lighten(CRIMSON, 0.85),
    criticalOutline: CRIMSON,
    outline: '#bdbdbd',
  },
  tooltip: {
    background: '#616161',
  },
  toggle: {
    off: '#bdbdbd',
    offHover: '#bdbdbd',
    on: '#659d68',
    onHover: '#659d68',
    offAlternate: '#314D87',
  },
  // sadly these need to match colors in the portal-ui repo
  portal: {
    background: {
      dark: '#1d1d1e',
      light: '#ffffff',
    },
  },
};

export const SurePathTheme: ThemeOptions = {
  ...defaultThemeOptions,
  palette,
};
